<template>
    <div>
        <vs-button @click="AddSubtitle">Add Subtitle</vs-button>
        <div class="m-4">
            <div class="card p-2  m-2 shadow rounded bordered" v-for="(subtitle, index) in subtitles" :key="index"
                :class="{ 'successUpload': subtitle.status }">
                <vs-progress v-if="subtitle.progress != 0 && !subtitle.status" :percent="subtitle.progress"
                    color="primary">primary</vs-progress>
                <div class="flex">
                    <vs-button radius color="danger" type="filled" icon="delete"
                        @click="delSubtitle(subtitle, index)"></vs-button>
                    <h4 class="m-2" v-if="subtitle.status">{{ subtitle.language.en_name }} (.{{ subtitle.sub.extention }})
                    </h4>
                    <vSelect v-if="!subtitle.status" :filterable="false" :multiple="false" v-model="subtitle.language"
                        style="width:200px" class="ml-3 mt-1" :options="$store.state.languages.all"
                        placeholder="Subtitle Language">
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.en_name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.en_name }}
                            </div>
                        </template>
                    </vSelect>
                    <input v-if="!subtitle.status" type="file" name="file" ref="file" class="ml-3 mt-2"
                        @change="handleUploadFile($event, index)">
                    <vs-button v-if="!subtitle.status" line-origin="left" color="success" type="line"
                        @click="upload(index)">Upload</vs-button>
                </div>



            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
export default {
    props: ['movie'],
    components: {
        vSelect
    },
    created() {
        this.$store.dispatch('languages/fetchLanguages');
        if (this.movie && this.movie.length != 0) {
            this.movie.response.subtitles.forEach(element => {
                this.subtitles.push({
                    id: element.id,
                    status: true,
                    progress: 0,
                    movie: this.movie.response.id,
                    sub: element,
                    language: { id: 1, ar_name: element.ar_name, en_name: element.en_name }
                })
            });
        }
    },
    data() {
        return {
            subtitles: []
        }
    },
    methods: {
        AddSubtitle() {
            this.subtitles.push({
                id: 0,
                language: 0,
                file: '',
                movie: this.movie.response.id,
                progress: 0,
                status: false,
                extention:'srt'
            });
        },
        handleUploadFile(event, subtitle) {
            this.subtitles[subtitle].file = event.target.files[0];
        },
        delSubtitle(subtitle, index) {
            if (subtitle.status) {
                this.axios.post(`${this.$apiUrl}/movies/delSubtitle/${subtitle.id}`).then(res => {
                    this.subtitles.splice(index, 1)
                })
            } else {
                this.subtitles.splice(index, 1)
            }

        },
        upload(subtitle) {
            const data = new FormData();
            data.append('language', JSON.stringify(this.subtitles[subtitle].language));
            data.append('file', this.subtitles[subtitle].file);
            data.append('movie', this.subtitles[subtitle].movie);
            var vm = this;
            let config = {
                onUploadProgress(progressEvent) {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) /
                        progressEvent.total);
                    vm.subtitles[subtitle].progress = percentCompleted;
                    return percentCompleted;
                },

            };
            this.axios.post(`${this.$apiUrl}/movies/uploadSubtitle/${this.movie.response.id}`, data, config).then(res => {
                this.subtitles[subtitle].status = true
                this.$emit('update')
                this.subtitles.splice(subtitle,1)
                this.subtitles[subtitle].id = res.data.response.id;
            })
        }
    },
}
</script>
<style lang="css">
.card {
    border: 1px solid #ccc;
}

.successUpload {
    background-color: rgba(30, 255, 0, 0.295)
}</style>